import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Core2Config } from '../shared/core2Config';
import { UserNotificationLinkContainerModel } from '../../../../../models/aggregates/user-notification-link';
import { BaseApiPublicLoginTemplateService } from '../shared/base-api-public-login-template.service';
import { ApiVisa, BasicApiResponseModel } from '../shared';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserNotificationLinkService extends BaseApiPublicLoginTemplateService<UserNotificationLinkContainerModel,UserNotificationLinkContainerModel,UserNotificationLinkContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'user-notification-links/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'user-notification-links/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.endpoint_path_login_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'user-notification-links/' + Core2Config.LOGIN_EP_SUFFIX;
    this.httpClient = http;
  }

  public updateReadStatus(userNtfLinkGuid: string, visa: ApiVisa): Observable<BasicApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      let apiUrl = visa.api_domain_url + this.endpoint_path + '/update-read-status/' + userNtfLinkGuid;

      return this.httpClient.get<BasicApiResponseModel<any>>(
        apiUrl,
        this.getHttpHeader(visa)
      );
    }
  }

  public updateReadStatusLogin(userNtfLinkGuid: string, visa: ApiVisa): Observable<BasicApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      let apiUrl = visa.api_domain_url + this.endpoint_path_login_url + '/update-read-status/' + userNtfLinkGuid;

      return this.httpClient.get<BasicApiResponseModel<any>>(
        apiUrl,
        this.getHttpHeader(visa)
      );
    }
  }
}